import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  brandKeyChip: {
    marginLeft: theme.spacing(1),
    color: 'white',
    position: 'relative',
    top: ({ isLoading }: { isLoading: boolean }) =>
      isLoading ? theme.spacing(-0.1) : 0,
  },
  subTitle: {
    display: 'block',
    opacity: 0.75,
    overflow: 'hidden',
    position: 'relative',
    textOverflow: 'ellipsis',
    top: theme.spacing(-0.25),
    whiteSpace: 'nowrap',
  },
  title: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  wrapper: {
    position: 'relative',

    '& > div > div:last-child': {
      marginBottom: ({ isLoading }: { isLoading: boolean }) =>
        isLoading ? theme.spacing(0.7) : 0,
    },
  },
}));
